export const ChatbotConfig = {
  api: {
    baseUrl: "/api/chat",
    timeout: 60000, 
    polling: {
      interval: 1000, 
      maxAttempts: 60  
    }
  },

  assistant: {
    assistantId: process.env.REACT_APP_OPENAI_ASSISTANT_ID,
    betaVersion: "assistants=v2"
  },

  ester: {
    welcomeMessage: "Hi! I'm Ester, your ClarityAI assistant. How can I help you today?",
    
    ui: {
      primaryColor: "#1890ff",
      assistantAvatarBg: "#1890ff",
      position: {
        bottom: "100px",
        right: "20px"
      }
    }
  }
};

export default ChatbotConfig;

